/** @format */

import React, { Component } from "react";
import "./investmentStyle.css";

import image3 from "../../assets/images/Artboard-1SHOPBACK-1-320x320.jpg";
import image1 from "../../assets/images/TradeGecko.png";
import billease from "../../assets/images/billease.png";
import bounceBack from "../../assets/images/bounceback.png";
import image2 from "../../assets/images/helicap-33-320x320.jpg";
import moduit from "../../assets/images/moduit.png";
import image6 from "../../assets/images/portfolio_5.jpg";
class Investment extends Component {
  render() {
    return (
      <div id="investments" className="clearfix dt_row">
        <div className="container">
          <div className="row">
            <div id="dt_column_40" className="dt_column col-sm-12">
              <div id="dt_row_41153717827727" className="row dt_row">
                <div id="dt_column_42" className="dt_column col-sm-12">
                  <div
                    id="dt-section-head-43"
                    className="dt-section-head center"
                  >
                    <div className="dt-section-container">
                      <h2 className="section-main-title section-heading-krypton ">
                        OUR INVESTMENTS
                      </h2>
                      <hr></hr>
                    </div>
                  </div>
                </div>
              </div>
              <div id="dt_row_44153717827786" className="row dt_row">
                <div id="dt_column_45" className="dt_column col-sm-12">
                  <div
                    id="portfolio-module46"
                    className="portfolio-module col-4"
                  >
                    <div className="portfolio-module-items isotope">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://quickbooks.intuit.com/"
                      >
                        <article
                          id="port-1529"
                          className="portfolio-item hover-this square current-investments post-1529 port type-port status-publish has-post-thumbnail hentry portcat-current-investments isotope-item"
                        >
                          <div className="top-image">
                            <img
                              className="img-responsive"
                              src={image1}
                              alt=""
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                          <div className="description">
                            <div className="slide-content">
                              <h4>TradeGecko</h4>
                            </div>
                          </div>
                        </article>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href=" https://www.helicap.com/"
                      >
                        <article
                          id="port-1529"
                          className="portfolio-item hover-this square current-investments post-1529 port type-port status-publish has-post-thumbnail hentry portcat-current-investments isotope-item"
                        >
                          <div className="top-image">
                            <img
                              className="img-responsive"
                              src={image2}
                              alt=""
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                          <div className="description">
                            <div className="slide-content">
                              <h4>Helicap</h4>
                            </div>
                          </div>
                        </article>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href=" https://www.shopback.sg/"
                      >
                        <article
                          id="port-1436"
                          className="portfolio-item hover-this square current-investments post-1436 port type-port status-publish has-post-thumbnail hentry portcat-current-investments isotope-item"
                        >
                          <div className="top-image">
                            <img
                              className="img-responsive"
                              src={image3}
                              alt=""
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                          <div className="description">
                            <div className="slide-content">
                              <h4>SHOPBACK</h4>
                            </div>
                          </div>
                        </article>
                      </a>
                      {/* <article id="port-224" className="portfolio-item hover-this portrait exited-investments post-224 port type-port status-publish has-post-thumbnail hentry portcat-exited-investments isotope-item">
                                            <div className="top-image">
                                                <img className="img-responsive" src={image4} alt="" />
                                            </div>
                                            <div className="description">
                                                <div className="slide-content">
                                                    <h4>CO Assets</h4>
                                                </div>
                                            </div>
                                        </article> */}
                      {/* <article id="port-223" className="portfolio-item hover-this square current-investments post-223 port type-port status-publish has-post-thumbnail hentry portcat-current-investments isotope-item">
                                            <div className="top-image">
                                                <img className="img-responsive" src={image5} alt="" />
                                            </div>
                                            <div className="description">
                                                <div className="slide-content">
                                                    <h4>Guava Pass</h4>
                                                </div>
                                            </div>
                                        </article> */}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.mcpayment.id/"
                      >
                        <article
                          id="port-221"
                          className="portfolio-item hover-this landscape exited-investments post-221 port type-port status-publish has-post-thumbnail hentry portcat-exited-investments isotope-item"
                        >
                          <div className="top-image">
                            <img
                              className="img-responsive"
                              src={image6}
                              alt=""
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                          <div className="description">
                            <div className="slide-content">
                              <h4>MC Payment</h4>
                            </div>
                          </div>
                        </article>
                      </a>
                      {/* <article id="port-218" className="portfolio-item hover-this square current-investments post-218 port type-port status-publish has-post-thumbnail hentry portcat-current-investments isotope-item">
                                            <div className="top-image">
                                                <img className="img-responsive" src={image7} alt="" />
                                            </div>
                                            <div className="description">
                                                <div className="slide-content">
                                                    <h4>Finsure</h4>
                                                </div>
                                            </div>
                                        </article> */}
                      {/* <article id="port-216" className="portfolio-item hover-this square current-investments post-216 port type-port status-publish has-post-thumbnail hentry portcat-current-investments isotope-item">
                                            <div className="top-image">
                                                <img className="img-responsive" src={image8} alt="" />
                                            </div>
                                            <div className="description">
                                                <div className="slide-content">
                                                    <h4>Boom Watches</h4>
                                                </div>
                                            </div>
                                        </article> */}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://moduit.id/"
                      >
                        <article
                          id="port-221"
                          className="portfolio-item hover-this landscape exited-investments post-221 port type-port status-publish has-post-thumbnail hentry portcat-exited-investments isotope-item"
                        >
                          <div className="top-image">
                            <img
                              className="img-responsive"
                              src={moduit}
                              alt=""
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                          <div className="description">
                            <div className="slide-content">
                              <h4>Moduit</h4>
                            </div>
                          </div>
                        </article>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://bback.co/"
                      >
                        <article
                          id="port-218"
                          className="portfolio-item hover-this landscape exited-investments post-218 port type-port status-publish has-post-thumbnail hentry portcat-exited-investments isotope-item"
                        >
                          <div className="top-image">
                            <img
                              className="img-responsive"
                              src={bounceBack}
                              alt=""
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                          <div className="description">
                            <div className="slide-content">
                              <h4>Bounceback</h4>
                            </div>
                          </div>
                        </article>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://billease.ph/"
                      >
                        <article
                          id="port-216"
                          className="portfolio-item hover-this landscape exited-investments post-216 port type-port status-publish has-post-thumbnail hentry portcat-exited-investments isotope-item"
                        >
                          <div className="top-image">
                            <img
                              className="img-responsive"
                              src={billease}
                              alt=""
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                          <div className="description">
                            <div className="slide-content">
                              <h4>Billease</h4>
                            </div>
                          </div>
                        </article>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Investment;



// WEBPACK FOOTER //
// ./src/components/Investment/index.js